import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import THEME from '../../../styles/colors';
import StyledButton, {
  ButtonFill,
  ButtonTheme
} from '../../../ui/Button/StyledButton';
import Icon from '../../../ui/Icon/Icon';

const StyledSearchForm = styled.form`
  height: 100%;
  display: flex;
  position: relative;
  flex: 2 1 auto;
  align-items: center;
  background-color: ${THEME.surface.primary};
  border-bottom: 1px solid ${THEME.general.border};
`;

const StyledSearchLabel = styled.label`
  width: 52px;
  height: 52px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 0;
  left: 0;
`;

const StyledSearchInput = styled.input`
  padding-left: 52px;
  padding-right: 20px;

  flex: 2 1 auto;

  border: 0;
  outline: none;
`;

const StyledSearchButton = styled(StyledButton)`
  transition: all 0.093s ease;
  margin-right: 16px;
  color: ${THEME.text.disabled};
  border-color: ${THEME.text.disabled};

  &:hover {
    border-color: ${THEME.brand.maxpreps};
    color: ${THEME.brand.maxpreps};
  }
`;

const SEARCH_ID = 'search-field';

const DesktopSearch = () => {
  const searchInput = useRef<HTMLInputElement>();

  useEffect(() => {
    searchInput?.current?.focus();
  }, []);

  return (
    <StyledSearchForm action="https://www.maxpreps.com/search/default.aspx">
      <StyledSearchLabel htmlFor={SEARCH_ID}>
        <Icon icon={faSearch} size={20} color={THEME.other.icon} />
      </StyledSearchLabel>
      <StyledSearchInput
        ref={searchInput as any}
        id={SEARCH_ID}
        placeholder="Search teams + athletes + videos"
        type="search"
        name="search"
      />
      <StyledSearchButton
        $fillMode={ButtonFill.Outline}
        $colorScheme={ButtonTheme.White}
        type="submit"
      >
        SEARCH
      </StyledSearchButton>
    </StyledSearchForm>
  );
};

export default DesktopSearch;
